import { useLocation } from "react-router-dom";

import { DEFAULT_TABLE_TAB } from "@ds/modules/table-data/redux/slice";
import { getMainTableDataTypeByRoute } from "@ds/modules/table-data/utils/helpers";

export const useCurrentTableDataType = () => {
  const { pathname } = useLocation();
  return [getMainTableDataTypeByRoute(pathname), DEFAULT_TABLE_TAB] as const;
};
